import { apolloClient } from '@/service/apolloClient'

import { magazineAll, magazinesByType, cmsCategories } from '@/pages/magazine/queries'
import {
  magazineAllTypes as MagazineAllTypes,
  cmsCategoryList as CmsCategoryList
} from '@/pages/magazine/types'
import {
  magazineTypeDetail as MagazineTypeDetail

} from '@/pages/magazine/queries/types/magazineTypeDetail'
import { MAGAZINE_TYPES } from '../consts'


export const getMagazineAllTypes = (limit: number) => {
  return apolloClient.query<MagazineAllTypes>({
    query: magazineAll,
    variables: {
      limit: limit
    }
  })
}

export const getMagazineAllTypeDetail = (itemType: string, itemOffset: number, itemLimit: number) => {
  if (itemType === MAGAZINE_TYPES.CATEGORY) {
    return apolloClient.query<CmsCategoryList>({
      query: cmsCategories,
      variables: {
        offset: itemOffset,
        limit: itemLimit
      }
    })
  }
  return apolloClient.query<MagazineTypeDetail>({
    query: magazinesByType,
    variables: {
      magazineType: itemType,
      offset: itemOffset,
      limit: itemLimit
    }
  })
}
